import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import ADDRESS_UPDATE from '../mutations/ADDRESS_UPDATE';

const useAddressUpdate = () => {
    const [ patchAddress ] = useMutation( ADDRESS_UPDATE );

    const saveAddress = async ( saveData ) => {
        try {
            const response = await patchAddress( { variables: { input: saveData } } );
            const success = response?.data?.patchAddress;

            if ( success ) {
                return {
                    success: true,
                    response
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error saving address', error );  
            return {
                success: false,
                response: error
            };
        } 
    };

    return useMemo( () => {
        return {
            saveAddress         
        };
    }, [] );
};

export default useAddressUpdate;
